export default {
  active: '启用',
  inactive: '停用',
  pending: '待处理',
  inProgress: '进行中',
  completed: '已完成',
  cancelled: '已取消',
  bizOrder: {
    DRAFT: '草稿',
    PENDING: '待订舱',
    PENDING_BOOKING: '待订舱',
    PENDING_MATCH: '待匹配',
    SUBMITTED: '待订舱',
    MATCHED: '已匹配',
    TRACKING: '跟踪中',
    WAREHOUSED: '已入仓',
    LOCKED: '已锁定',
    COMPLETED: '已完成',
    CANCELLED: '已撤单',
    PENDING_VIEWED: '待订舱(航线已查看)',
    PENDING_UNVIEWED: '待订舱(航线未查看)',
  },
  bizOrderTab: {
    DRAFT: '草稿箱',
    PENDING: '待订舱',
    TRACKING: '跟踪中',
    LOCKED: '已锁定',
  },
  productOrder: {
    DRAFT: '草稿',
    PRE_BOOKED: '预占待售',
    PREBOOKED: '预占待售',
    MATCHED: '已匹配',
    LOCKED: '已锁定',
    IN_TRANSIT: '执行中',
    EXECUTING: '执行中',
    ARRIVED: '已到达',
    ALERT: '告警',
    ARCHIVED: '已归档',
    DISSOLVED: '已撤舱',
    COMPLETED: '已完成',
  },
  hawb: {
    DRAFT: '草稿',
    CONFIRMED: '已确认',
    ISSUED: '已签发',
    VOID: '已作废',
  },
  agreement: {
    ACTIVE: '生效',
    OVERSOLD: '超卖',
    EXPIRED: '失效',
  },
  paymentStatus: {
    PAID: '已收',
    PARTIAL: '部分',
    UNPAID: '未收',
  },
  payStatus: {
    PAID: '已付',
    UNPAID: '未付',
  },
  changeRequest: {
    PENDING: '待处理',
    APPROVED: '已同意',
    REJECTED: '已驳回',
  },
}
